export class Country {
  public id: string;
  public name: string;
  public code: string;
  public code2: string;
  public static readonly UnitedStates = Country.parse({
    id: 840,
    name: 'United States of America',
    code: 'USA',
    code2: 'US'
  });

  public static readonly Canada = Country.parse({
    id: 124,
    name: 'Canada',
    code: 'CAN',
    code2: 'CA'
  });

  constructor(id: string, name: string, code: string, code2: string) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.code2 = code2;
  }

  static parse(obj: any): Country {
    if (!obj) return;
    return new Country(obj.id, obj.name, obj.code, obj.code2);
  }
}
